import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import { usesMomentsScheduling } from '@/features/appointments/schedulingProvider';
import { isCoach } from '@/types/user';

const redirectTarget = (
  pathname: string,
  location: ReturnType<typeof useLocation>,
) => ({
  hash: location.hash,
  pathname,
  search: location.search,
});

const StatePreservingRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  return (
    <Navigate
      to={redirectTarget(to, location)}
      {...{ replace: true, state: location.state }}
    />
  );
};

export const LegacySessionsRedirect = ({
  tab,
}: {
  tab: 'past' | 'upcoming';
}) => {
  const { user } = useCurrentUser();
  return (
    <StatePreservingRedirect
      to={`${isCoach(user) ? '/coach' : '/m'}/sessions/${tab}`}
    />
  );
};

export const CoachSessionsIndexRedirect = () => (
  <StatePreservingRedirect to="/coach/sessions/upcoming" />
);

export const MemberSessionsIndexRedirect = () => (
  <StatePreservingRedirect to="/m/sessions/upcoming" />
);

export const LegacySessionDetailRedirect = ({
  summary = false,
}: {
  summary?: boolean;
}) => {
  const { user } = useCurrentUser();
  const { sessionId = '' } = useParams();
  const suffix = summary ? '/summary' : '';
  return (
    <StatePreservingRedirect
      to={`${isCoach(user) ? '/coach' : '/m'}/sessions/${sessionId}${suffix}`}
    />
  );
};

export const CoachSessionsGate = () => {
  const { user, isUserLoading } = useCurrentUser();

  // Do not mount a legacy session page until this coach's provider is known.
  if (isUserLoading) return null;

  if (usesMomentsScheduling(user)) {
    return <StatePreservingRedirect to="/coach/schedule" />;
  }

  return <Outlet />;
};
